import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { auth } from './Core/firebaseCore';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout, selectUser } from './Store/Reducers/userSlice';

import Loading from './Screens/Components/Loading';
import LoginScreen from './Screens/LoginScreen';
import HomeScreen from './Screens/HomeScreen';
import Header from './Screens/Components/Header';
import Categories from './Screens/Components/Categories';
import Footer from './Screens/Components/Footer';
import PrivacyScreen from './Screens/PrivacyScreen';
import TermsScreen from './Screens/TermsScreen';
import VideoScreen from './Screens/VideoScreen';
import VideoListScreen from './Screens/VideoListScreen';
import NotFound from './Screens/Components/NotFound';

function App() {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((userAuth) => {
      if (userAuth) {
        dispatch(login({ uid: userAuth.uid, email: userAuth.email }));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    });
    return unsubscribe;
  }, []);

  const signOut = (e) => {
    auth.signOut().then(() => {
      dispatch(logout());
      window.location.assign("/");
    }).catch((error) => { console.log(error); });
  }

  return (
    <div className="App">
      {process.env.NODE_ENV == 'development' ?
        (<div><small>You are running this application in <b>{process.env.NODE_ENV}</b> mode.</small></div>) : ('')}
      {isLoading ? (<Loading />) : (
        <Router>
          {!user && user == null ? (<LoginScreen />)
            : (<>
              <div className="app_body">
                <Header signOut={signOut} user={user} />
                <Categories />
                <div className="screen_container">
                  <Switch>
                    <Route path="/home" render={() => <HomeScreen />} />
                    <Route path="/video/:videoId" render={() => <VideoScreen />} />
                    <Route exact path="/videos/:category" render={() => <VideoListScreen />} />
                    <Route path="/terms" render={() => <TermsScreen />} />
                    <Route path="/privacy-policy" render={() => <PrivacyScreen />} />
                    <Route exact path="/" render={() => <HomeScreen />} />
                    <Route path="*" render={() => <NotFound />} />
                  </Switch>
                </div>
                <Footer />
              </div>
            </>)
          }
        </Router>
      )}
    </div>
  );
}

export default App;
